import { commonComponents as cc } from "@/components/common";
import { services as s } from "@/services";

import { Copy } from "@/components/common/Copy";
import type { SharedAttributeJSON } from "@/features/shared_attributes/types";
import { useAuth } from "@/utils/auth";
import dayjs from "dayjs";
import type { StatefulObservationViewT } from "../../../types/database/observations";
import { useDiaryByIdQuery } from "../../diaries/api";
import SharedAttributeContactPerson from "../../shared_attributes/components/SharedAttributeContactPerson";
import SharedAttributeDatePicker from "../../shared_attributes/components/SharedAttributeDatePicker";
import ObservationNameForm from "./ObservationNameForm";

interface Props {
	observation: StatefulObservationViewT;
}

const EditObservation = ({ observation }: Props) => {
	const auth = useAuth();
	const { data: diary } = useDiaryByIdQuery(observation.diary_id);

	if (!observation || !diary) {
		return <p>No Observation</p>;
	}

	const sharedAttributes = diary.shared_attributes as
		| SharedAttributeJSON
		| undefined;

	// Format the observation date as a string
	const formattedDate =
		typeof observation.observation_date === "string"
			? observation.observation_date
			: observation.observation_date
				? dayjs(observation.observation_date).toISOString()
				: "";

	return (
		<>
			<cc.EditDialog
				label="Name"
				description="The name of this observation"
				info={observation.observation_name}
				noInfo={!observation.observation_name}
			>
				<ObservationNameForm
					diaryId={observation.diary_id}
					observationId={observation.observation_id}
					observationName={observation.observation_name ?? ""}
				/>
			</cc.EditDialog>

			<cc.EditDialog
				label="Observation Date"
				info={s.time.formatShortDateTime(formattedDate)}
				noInfo={!formattedDate}
			>
				<SharedAttributeDatePicker
					dateType="reference_date"
					sharedAttributes={sharedAttributes}
				/>
			</cc.EditDialog>
		</>
	);
};

export default EditObservation;
